//useEffect = Método chamado ao carragar a página;
import React, { useEffect, useState, useContext} from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
//import { Link } from 'react-router-dom';
//import logo from '../../assets/logo.png';
import Api from '../../services/Api'
import Functions from '../../components/Functions'
import iconBusiness from '../../assets/icons/business.png';
import ListItemBusiness from '../../components/ListItemBusiness'
import ListItemUser from '../../components/ListItemUser';
import iconProfileWhite from '../../assets/icons/icon-profile-white.png';
import './styles.css';
import '../../App.css';
import UserContext from '../../contexts/UserContext';
import BodyPlans from '../Index/BodyPlans';

export default function DashboardBusiness(props) {
  const { t } = useTranslation();
  const [business, setBusiness] = useState({});
  const [editBusiness, setEditBusiness] = useState(false);
  const [editUser, setEditUser] = useState(false);
  const [plans, setPlans] = useState([]);
  const [changePlan, setChangePlan] = useState(false);
  const {user, setUser} = useContext(UserContext);
  const location = useLocation();
  const history = useHistory();

  // Executa assim q a página é aberta;
  useEffect(() => {
    props.setLoading(true);
    loadBusiness();
    if(history.location.search.indexOf('editBusiness') !== -1){
      setTimeout(() => {
        setEditBusiness(true);
      }, 500);
    } else if(history.location.search.indexOf('editUser') !== -1){
      setTimeout(() => {
        setEditUser(true);
      }, 500);
    }
    if(!user[0].business?.name || user[0].business.name === "") {
      setEditBusiness(true);
    }
  }, []);

  async function loadBusiness() {
    try {
      const response = await Api.get(`/get-business/${user[0].business._id}`);
      console.log(response);
      setBusiness(response);
      loadPlans();
    } catch (error) {
      console.log(error)
    }
  }

  async function loadPlans() {
    try {
      const response = await Api.get(`/get-plans-active/true`);
      console.log(response);
      setPlans(response);
      props.setLoading(false);
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div id="businessList" className="bodyDashboard" style={{paddingTop: 15}}>
      <br />
      <div className="v-center">
        <div className="col-6">
          <span className="title">{t('dashboardBusiness.title')}</span>
        </div>
        <div className="col-6 text-right">
        </div>
      </div>
      <div className="col-12">
        <div className="itemHome" style={{padding: 0, cursor: "initial", margin: "15px 0px"}}>
          {editBusiness ?
            <div className="col-12">
              <div className="text-center" style={{paddingTop: 20}}>
                <h3>{t('dashboardBusiness.clinicInfo.title')}</h3>  
              </div>
              <ul className="dashboardLists"> 
                <ListItemBusiness
                  key={business._id}
                  item="editBusiness"
                  id={business._id}
                  user={user[0]._id}
                  name={business?.name ? business.name : ""}
                  CNPJ={business?.CNPJ ? business.CNPJ : ""}
                  description={business?.description ? business.description : ""}
                  thumbnail={business?.thumbnail ? business.thumbnail : ""} 
                  address={business?.address && business.address?.street ? business.address : {street: "", number:"", district: "", complement: "", city: "", state: "", country: ""}} 
                  maps={business?.maps ? business.maps : { irisLeft: [], irisRight: [] }} 
                  phone={business?.phone ? business.phone : ""} 
                  email={business?.email ? business.email : ""}
                  openingHours={business?.openingHours ? business.openingHours : []}
                  schedulingTime={business?.schedulingTime ? business.schedulingTime : 59}
                  //cities={cities}
                  //whatsapp={business.whatsapp} 
                  //instagram={business.instagram} 
                  //facebook={business.facebook} 
                  //website={business.website} 
                  active={business.active} 
                  //onDelete={() => removeBusiness(business._id)}
                  setEditBusiness={(value) => setEditBusiness(value)}
                  loadItem={() => loadBusiness()}
                  setLoading={props.setLoading}
                  //ref={childRef}
                />
              </ul>
            </div>
          : <>
            <div className="v-center"> 
              <div className="col-12 col-md-3 text-center"> 
                <label id="imgBusiness" style={{ backgroundImage: `url("${business?.thumbnail ? encodeURI(business.thumbnail) : iconBusiness}")` }}></label>
              </div>
              <div className="col-12 col-md-9" style={{paddingTop: 12, paddingBottom: 12}}>
                <div><b style={{fontSize: 20}}>{business?.name ? business.name : t('dashboardBusiness.clinicInfo.emptyData')}</b></div>
                <div>{business.address?.street && business.address.street !== "" ? business.address.street + ", " + business.address.number + ", " + business.address.district + " - " + business.address.city + ", " + business.address.state : ""}</div>
                <button type="button" onClick={() => setEditBusiness(!editBusiness)} className="btn btn-default" style={{marginTop: 15}}>{t('dashboardBusiness.clinicInfo.editButton')}</button>
              </div>
            </div>
          </>}
        </div>
      </div>
      <br />
      <div className="v-center">
        <div className="col-6">
          <span className="title">{t('dashboardBusiness.profile.title')}</span>
        </div>
        <div className="col-6 text-right">
        </div>
      </div>
      <div className="col-12">
        <div className="itemHome" style={{padding: 0, cursor: "initial", margin: "15px 0px"}}>
          {editUser ?
            <div className="col-12">
              <div className="text-center" style={{paddingTop: 20}}>
                <h3>{t('dashboardBusiness.profile.personalInfo')}</h3>  
              </div>
              <ul className="dashboardLists"> 
                <ListItemUser
                  view="editUser"
                  _id={user[0]._id}
                  business={business}
                  name={user[0].name}
                  thumbnail={user[0]?.thumbnail ? user[0].thumbnail : ""} 
                  email={user[0]?.email ? user[0].email : ""}
                  phone={user[0]?.phone ? user[0].phone : ""}
                  cpf={user[0]?.cpf ? user[0].cpf : ""}
                  birthDate={user[0]?.birthDate ? user[0].birthDate : ""}
                  address={user[0]?.address ? user[0].address : {street: "", number:"", district: "", complement: "", city: "", state: "", country: ""}} 
                  active={user[0]?.active ? user[0].active : true} 
                  onChangeUser={(userSelected) => { console.log(userSelected); } }
                  setEditUser={(value) => setEditUser(value)}
                  //onDelete={() => removeUser(user[0]._id)}
                  loadItem={() => props.reloadUser()}
                  setLoading={props.setLoading}
                />
              </ul>
            </div>
          : <>
            <div className="v-center"> 
              <div className="col-12 col-md-3 text-center"> 
                <label id="imgUser" style={{ backgroundImage: `url("${user[0]?.thumbnail ? encodeURI(user[0].thumbnail) : iconProfileWhite}")` }}></label>
              </div>
              <div className="col-12 col-md-9" style={{paddingTop: 12, paddingBottom: 12}}>
                <div><b style={{fontSize: 20}}>{user[0].name}</b></div>
                <div>{user[0].email}</div>
                <div><button type="button" onClick={() => props.setModalPassword(!props.modalPassword)} className="btnLink">{t('dashboardBusiness.profile.changePassword')}</button></div>
                <button type="button" onClick={() => setEditUser(!editUser)} className="btn btn-default" style={{marginTop: 15}}>{t('dashboardBusiness.profile.editButton')}</button>
              </div>
            </div>
          </>}
        </div>
      </div>
      {changePlan &&
          <div id="bodyPlans">
            <BodyPlans />
          </div>  
        }
      <br />
      <div className="v-center">
        <div className="col-6">
          <span className="title">{t('dashboardBusiness.plan.title')}</span>
        </div>
        <div className="col-6 text-right">
        </div>
      </div>
      <div className="col-12">
        {business?.subscription ?
          <div className="itemHome" style={{cursor: "initial", margin: "15px 0px"}}>
            <div className="row">
              <div className="col-12" style={{marginBottom: 5}}>
                <span className="title">{business?.plan ? business.plan.name: ""}</span>
              </div>
              <div className="col-12 col-md-6">
                <div><span>{t('dashboardBusiness.plan.subscription')} </span><b>#{business.subscription.subs_key}</b></div>
                <div><span>{t('dashboardBusiness.plan.startDate')} </span><b>{moment(business.subscription.subs_createdate).format("DD/MM/YYYY [às] HH:mm")}</b></div>
                <div><span>{t('dashboardBusiness.plan.periodicity')} </span><b>{business.plan.days} {t('dashboardBusiness.plan.days')}</b></div>
              </div>
              <div className="col-12 col-md-6">
                <div><span>{t('dashboardBusiness.plan.status')}: </span><b>{business.subscription.subs_status}</b></div>
                <div><span>{t('dashboardBusiness.plan.validUntil')} </span><b>{moment(business.subscription.expiration_date).format("DD/MM/YYYY [às] HH:mm")}</b></div>
                <div><span>{t('dashboardBusiness.plan.nextCharge')} </span><b>{business.subscription.subs_status !== 'canceled' ? moment(business.subscription.subs_next_charge).format("DD/MM/YYYY") : " - "}</b></div>
              </div>
              <div className="col-12 col-md-6">
                <button type="button" onClick={() => {
                  business?.subscription?.provider === "stripe" ?
                  window.open("https://billing.stripe.com/p/login/fZe6pS9PL6tqckE8ww", "_blank") :
                  window.open("https://compras.braip.com/?tab=assinaturas", "_blank")
                  }} 
                  className="btn btn-default" style={{marginTop: 15, fontSize: 14}}>{t('dashboardBusiness.plan.manageSubscription')}</button>
              </div>
              <div className="col-12 col-md-6">
                <button type="button" onClick={() => setChangePlan(true) } 
                  className="btn btn-delete" style={{marginTop: 15, fontSize: 14}
                }>{t('dashboardBusiness.plan.changePlan')}</button>
              </div>
            </div>
          </div>  
        : <></> }
      </div>
      <br />
      {/*<div className="v-center">
        <div className="col-6">
          <span className="title">Faturas</span>
        </div>
        <div className="col-6 text-right">
        </div>
      </div>
      <div className="col-12">
        <hr />
        <p>Suas faturas aparecerão aqui...</p>
      </div>*/}
    </div>
  )
}